import { jsx as _jsx } from "react/jsx-runtime";
import { List, Typography } from '@mui/material';
import { ContactListItem } from './ContactListItem.js';
export function ContactsList(props) {
    const { contacts, selectedContactId, onContactSelect } = props;
    if (contacts.length === 0) {
        return (_jsx(Typography, { variant: "body2", color: "text.secondary", sx: { textAlign: 'center', mt: 4, px: 2 }, children: "No contacts found." }));
    }
    return (_jsx(List, { sx: { overflow: 'auto', flex: 1, minHeight: 0, py: 0 }, children: contacts.map((contact) => (_jsx(ContactListItem, { contact: contact, isSelected: contact.id === selectedContactId, onClick: () => onContactSelect(contact) }, contact.id))) }));
}
//# sourceMappingURL=ContactsList.js.map